import { format, formatDuration, intervalToDuration, isToday, isYesterday } from 'date-fns'
import { id } from 'date-fns/locale'

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
const formatDate = (dt: string | number | Date, fmt: string = 'PP') => {
  return format(dt, fmt, { locale: id })
}
export default {
  /**
   * Format date with given string format. Set locale to id
   * See https://date-fns.org/docs/format for accepted tokens
   */
  date: formatDate,

  dateLong: (dt: string | number | Date) => {
    return formatDate(dt, 'cccc, dd MMMM yyyy HH:mm')
  },

  /**
   * Shorter format date. If date is today, it will only show time,
   * otherwise show the date.
   */
  dateShort: (dt: string | number | Date) => {
    if (isToday(dt)) {
      return formatDate(dt, 'HH:mm')
    }
    if (isYesterday(dt)) {
      return 'Kemarin'
    }

    return formatDate(dt)
  },

  dateForm: (dt: string | number | Date) => {
    return formatDate(dt, 'yyyy-MM-dd')
  },
  /**
   * Get texts of calculation duration of two dates in human readable format.
   * e.g: 5 bulan 3 hari 2 jam
   * See https://date-fns.org/docs/formatDuration
   */
  duration: (dtStart: unknown, dtEnd: unknown) => {
    if (
      typeof dtStart !== 'number' &&
      typeof dtStart !== 'string' &&
      !(dtStart instanceof Date)
    ) {
      return '-'
    }
    if (
      typeof dtEnd !== 'number' &&
      typeof dtEnd !== 'string' &&
      !(dtEnd instanceof Date)
    ) {
      return '-'
    }

    const duration = intervalToDuration({
      start: new Date(dtStart),
      end: new Date(dtEnd),
    })

    return formatDuration(duration, {
      locale: id,
      // format: ['years', 'months', 'days', 'hours', 'minutes'],
    })
  },

  formToday: () => formatDate(new Date(), 'yyyy-MM-dd'),

}
